import { Component } from '@angular/core';
import { PwaService } from '@core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(private pwaService: PwaService) {
    this.pwaService.subscribeForUpdates();
  }
}
